<div class="ui-g-12 no-padding">
	<ng-template
		[ngIf]="loading"
		[ngIfElse]="Content">
		<div class="ui-g-12 no-horizontal-padding text-center">
			<i class="loading-spinner theme-color fa fa-fw fa-spin fa-spinner">
			</i>
		</div>
	</ng-template>

	<ng-template #Content>
		<div class="ui-g-12 no-padding">
			<div class="ui-g-12 no-padding dynamic-form-content">
				<app-dynamic-formly
					[dataSet]="currentData"
					[layoutSchema]="dynamicFormlyLayout"
					[context]="context"
					(validityChanged)="dynamicFormlyValidityChanged($event)">
				</app-dynamic-formly>
			</div>
			<div>
				<p>&nbsp;</p>
			</div>
		</div>
	</ng-template>
</div>